module.exports = __webpack_public_path__ + "img/sv71.f99f035b.svg";